import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AiTrackDayService } from '../../../services/index';

@Component({
    selector: 'add-edit-ai-track-day',
    templateUrl: './addEditAiTrackDay.component.html'
})
export class AddEditAiTrackDayComponent implements OnInit {
    public title: string;
    public trackDayData: any = {};
    isLoading = false;
    statusList = ['Active', 'Inactive'];

    @Output() loadEvent = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private aiTrackDayService: AiTrackDayService
    ) {}

    ngOnInit() {
        if (!this.trackDayData.status) {
            this.trackDayData.status = 'Active';
        }
    }

    onSave() {
        this.isLoading = true;
        this.aiTrackDayService.save(this.trackDayData).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');
                this.bsModalRef.hide();
                this.loadEvent.emit();
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiTrackDay/addEditAiTrackDay.component.ts